import { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';

export const Modal = ({ isOpen, onClose, title, children, footer, size = 'medium', isStatic = false }) => {
	const modalRef = useRef(null);
	const [shake, setShake] = useState(false);

	useEffect(() => {
		const handleEscape = (event) => {
			if (event.key === 'Escape' && !isStatic) {
				onClose();
			}
		};

		if (isOpen) {
			document.addEventListener('keydown', handleEscape);
		}

		return () => {
			document.removeEventListener('keydown', handleEscape);
		};
	}, [isOpen, onClose, isStatic]);

	if (!isOpen) return null;

	const sizeClasses = {
		small: 'max-w-md',
		medium: 'max-w-3xl',
		large: 'max-w-6xl',
		Xlarge: 'max-w-[80%]',
		XXlarge: 'max-w-[90%]',
	};

	const modalSizeClass = sizeClasses[size] || (size.startsWith('max-w-') ? size : sizeClasses.medium);

	const handleBackdropClick = (event) => {
		if (modalRef.current && !modalRef.current.contains(event.target)) {
			if (isStatic) {
				setShake(true);
				setTimeout(() => setShake(false), 300);
			} else {
				onClose();
			}
		}
	};

	return (
		<div
			className="fixed inset-0 z-[200] overflow-auto bg-black/70 flex items-center justify-center p-4 !m-0"
			onClick={handleBackdropClick}
		>
			<div
				ref={modalRef}
				className={`bg-card rounded-lg shadow-xl w-full ${modalSizeClass} ${
					shake ? 'animate-shake' : ''
				} flex flex-col max-h-[90vh] transition-all delay-120 duration-300 ease-in-out transform`}
			>
				{title && (
					<div className="border-b border-border px-4 py-2 flex items-center justify-between flex-shrink-0 gap-x-3">
						<h3 className="py-2 w-full font-semibold text-lg text-foreground">{title}</h3>

						{onClose && (
							<button
								onClick={onClose}
								className="text-foreground hover:text-foreground close-modal"
							>
								<X className="h-6 w-6" />
							</button>
						)}
					</div>
				)}

				<div className="p-4 flex-1 flex flex-col min-h-0">{children}</div>
				{footer && <div className="border-t border-border px-4 py-3 flex-shrink-0">{footer}</div>}
			</div>
		</div>
	);
};
